import { forwardRef, type Ref, type SVGProps } from "react";
const IconClapOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.618 4.597a2.677 2.677 0 0 1 3.273 1.82 2.68 2.68 0 0 1 3.111.488h.004a2.68 2.68 0 0 1 .49 3.112 2.676 2.676 0 0 1 1.132 4.458l-.453.452a2.675 2.675 0 0 1 .993 4.412l-2.403 2.403-.017.018-5.676 5.677a7.654 7.654 0 0 1-10.812 0l-1.07-1.07a9.12 9.12 0 0 1-2.69-6.488V12.84a2.68 2.68 0 0 1 2.432-2.707 2.68 2.68 0 0 1 1.63-2.225 2.677 2.677 0 0 1 3.71 2.511v.027l2.743-2.742.006-.007 2.415-2.414a2.7 2.7 0 0 1 1.181-.686m-1.728 3.9a1.15 1.15 0 0 0-.792.284l-4.048 4.051-.005.003-2.416 2.418a.77.77 0 0 1-.838.168.77.77 0 0 1-.413-.416.8.8 0 0 1-.054-.292V12.84a1.147 1.147 0 1 0-2.293 0v7.04c0 2.027.805 3.971 2.239 5.405l1.066 1.066a6.12 6.12 0 0 0 6.666 1.326 6.1 6.1 0 0 0 1.985-1.326l5.675-5.677a1.147 1.147 0 1 0-1.619-1.62l-2.98 2.969a.766.766 0 0 1-1.05-.028.766.766 0 0 1-.03-1.051l5.136-5.136a1.15 1.15 0 0 0 .05-1.668 1.15 1.15 0 0 0-1.576-.044l-2.808 2.808-.002.002-2.418 2.418a.764.764 0 0 1-1.08-1.079l6.218-6.218a1.15 1.15 0 0 0 0-1.62v-.002a1.15 1.15 0 0 0-1.62 0l-6.217 6.217a.77.77 0 0 1-.851.2.764.764 0 0 1-.229-1.279l5.127-5.138a1.147 1.147 0 0 0-.823-1.909m8.397 7.753a1.15 1.15 0 0 0-.823.384l-.173.172q-.04.045-.084.089l-.453.453a2.68 2.68 0 0 1 1.62 1.614l.71-.709a1.15 1.15 0 0 0 .303-1.28 1.15 1.15 0 0 0-1.1-.723m-.543-4.866a1.15 1.15 0 0 0-.823.385l-.714.713a2.67 2.67 0 0 1 1.624 1.614l.71-.708a1.15 1.15 0 0 0 .048-1.668 1.15 1.15 0 0 0-.844-.336M7.598 9.273a1.15 1.15 0 0 0-1.146 1.146h-.053a2.68 2.68 0 0 1 1.453 2.42v.028l.892-.892v-1.556a1.147 1.147 0 0 0-1.146-1.146M21.114 7.65c-.304 0-.595.12-.81.334l-.717.715c.372.133.712.345.994.626h.004c.281.282.493.622.625.993l.714-.713a1.15 1.15 0 0 0 0-1.62l-.002-.001a1.15 1.15 0 0 0-.808-.334M17.31 6.076a1.15 1.15 0 0 0-.796.29l-.713.711a2.67 2.67 0 0 1 1.621 1.62l.711-.712a1.148 1.148 0 0 0-.823-1.909"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M28.827 7.61a.675.675 0 0 1 0 1.35h-1.909a.675.675 0 0 1 0-1.35z"
    />
    <path
      fill="currentColor"
      d="M28.268 3.48a.675.675 0 0 1 .476 1.152l-1.43 1.432a.675.675 0 0 1-.954-.954l1.43-1.431a.68.68 0 0 1 .478-.198"
    />
    <path
      fill="currentColor"
      d="M24.352 2.343a.675.675 0 0 1 .543.661v1.907a.676.676 0 0 1-1.151.478.68.68 0 0 1-.199-.478V3.004a.676.676 0 0 1 .807-.661"
    />
  </svg>
);
const ForwardRef = forwardRef(IconClapOutlineSVG);
ForwardRef.displayName = "IconClapOutline";
export { ForwardRef as IconClapOutline };
